// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3HSou","actionsCol":"EnrolledClinics_actionsCol__14rPj"};